// actions
export const EMIT_SAVE_USER_INFORMATION = 'EMIT_SAVE_USER_INFORMATION';
export const EMIT_SAVE_ASSESSMENT = 'EMIT_SAVE_ASSESSMENT';
export const EMIT_SAVE_DICTIONARY = 'EMIT_SAVE_DICTIONARY';
export const EMIT_SAVE_ANSWERERINFO = 'EMIT_SAVE_ANSWERERINFO';

// mutations
export const SAVE_USER_INFORMATION = 'SAVE_USER_INFORMATION';
export const SAVE_ASSESSMENT = 'SAVE_ASSESSMENT';
export const SAVE_DICTIONARY = 'SAVE_DICTIONARY';
export const SAVE_ANSWERERINFO = 'SAVE_ANSWERERINFO';

// getters
export const GET_USER_INFORMATION = 'GET_USER_INFORMATION';
export const GET_ASSESSMENT = 'GET_ASSESSMENT';
export const GET_DICTIONARY = 'GET_DICTIONARY';
export const GET_ANSWERERINFO = 'GET_ANSWERERINFO';



// WEBPACK FOOTER //
// ./src/store/types.js